import { computed } from 'vue';
import { useStore } from 'vuex';

export const useSiteParameter = param => {
  const store = useStore();
  return computed(() => store.getters['currentUser/currentSiteParameters'][param]);
};
